import { gatewayFetch } from "src/managers/GatewayProxy";


export class cvrCollector {

   static async PEnhederPåBeliggenhed(beliggenhed: string) {
      return fetchCVR_ES({
         "size": 20,
         "_source": [
            "VrproduktionsEnhed.produktionsEnhedMetadata"
         ],
         "query": {
            "term": {
               "VrproduktionsEnhed.produktionsEnhedMetadata.nyesteBeliggenhedsadresse.adresseId.keyword": beliggenhed
            }
         }
      }, "produktionsenhed")
   }




}

async function fetchCVR_ES(query: any, index: string = "virksomhed"): Promise<any> {
   // Elasticsearch body
   let esBody = {
      funktion: "hentQuery",
      "query": { ...query, size: 100 },
      "index": index
   };

   return gatewayFetch("dll", "getcvrdata", { body: esBody }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      return response.json();
   });
}